import React from 'react';
import '../../../styles/Home.css';
import CommonMarketLaw from './Rankings/CommonMarketLaw'
import ComparativeLabourLaw from './Rankings/ComparativeLabourLaw'
import JournalOfWorldTrade from './Rankings/JournalOfWorldTrade'
import EconomicIntegration from './Rankings/EconomicIntegration'

const RankingTag = (props) => {
    
    if(props.name === "Common Market Law Review")
    return (
        <CommonMarketLaw/>
    )
    else if(props.name === "International Journal of Comparative Labour Law and Industrial Relations")
    return(
        <ComparativeLabourLaw/>
    )
    else if(props.name === "Journal of World Trade")
    return(
        <JournalOfWorldTrade/>
    )
    else if(props.name === "Legal Issues of Economic Integration")
    return(
        <EconomicIntegration/>
    )
    else
    return(
        <div></div>
    )
};

export default RankingTag;


// WEBPACK FOOTER //
// ./src/components/Journals/Subitems/RankingTag.jsx